export const StaticUserPicture =
  "/static/mock-images/avatars/avatar_default.jpg";

/**
 * API adresi .env dosyalarından okunur (.env.development / .env.production).
 * NODE_ENV'e gömülü sabit URL'ler, test ortamına build alırken yanlış
 * backend'e bağlanmaya yol açıyordu.
 */
const API_URL = process.env.REACT_APP_API_URL;

if (!API_URL) {
  throw new Error(
    "REACT_APP_API_URL tanımlı değil. .env.example dosyasını .env.local olarak kopyalayın."
  );
}

export const APP_CONFIG = { API_URL };

export const appLanguages = [
  {
    name: "Türkçe",
    value: "tr",
  },
  {
    name: "English",
    value: "en",
  },
  {
    name: "German",
    value: "de",
  },
  {
    name: "Spanish",
    value: "es",
  },
  {
    name: "French",
    value: "fr",
  },
];
